import { useLoaderData, useOutletContext, Link, useNavigate } from "react-router-dom"
import CupDisplay from "../../../mk8dx/components/track-components/CupDisplay";
import WorldCup from "../../../world/components/Cup";
import Button from "../../components/Button/Button";
import "./Profile.css";
import { useLayoutEffect, useState } from "react";
import SmallPop from "../../components/pops/SmallPop";
import { isMobile } from "react-device-detect";
import { toPng } from "html-to-image";

import { ReactComponent as ShareIcon } from "../../../assets/icons/svg/share-svgrepo-com.svg";
import { ReactComponent as PenIcon } from "../../../assets/icons/svg/pen-svgrepo-com.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/icons/svg/download-minimalistic-svgrepo-com.svg";

export default function Profile() {
    const data = useLoaderData();
    const [auth, setCurrentGame] = useOutletContext();
    const navigate = useNavigate();
    const [smallPop, setSmallPop] = useState();

    // Inform parent layout about which cups this user has
    useLayoutEffect(() => {
        if (setCurrentGame) {
            const hasWorldCups = data?.worldCups && data.worldCups.length > 0;
            const hasMk8dxCups = data?.cups && data.cups.length > 0;
            
            // Update game context based on cups - default to world if both
            if (hasWorldCups && !hasMk8dxCups) {
                setCurrentGame('world');
            } else if (hasMk8dxCups && !hasWorldCups) {
                setCurrentGame('mk8dx');
            } else if (hasWorldCups && hasMk8dxCups) {
                // User has both: prefer world
                setCurrentGame('world');
            }
        }
    }, [data, setCurrentGame]);

    useLayoutEffect(() => {
        const timemout = setTimeout(() => {
            setSmallPop(null);
        }, 3500);

        return () => clearTimeout(timemout);
    }, [smallPop])

    return <div id="main-container">
        <div>
            <div id="profile-container">
                <div id="name-container">
                    <h1>
                        {data?.displayName}
                    </h1>
                    {data?.id === auth.currentUser?.uid &&
                        <Button
                            text="Edit Profile"
                            onClick={(e) => {
                                e.preventDefault();
                                navigate(`/profile/${data.displayName}/edit`)
                            }}
                            icon={PenIcon}
                        />}
                </div>
                <Button
                    icon={ShareIcon}
                    text="Copy Link to Profile"
                    onClick={(e) => {
                        e.preventDefault();
                        navigator.clipboard.writeText("https://mk8dx-cup-builder.web.app"
                            + `/profile/${data.displayName}`);
                        setSmallPop(true);
                    }}
                />
            </div>

            <div id="pfp-user-cups">
                {data?.worldCups?.length > 0 && (
                    <>
                        <h2>{data?.displayName}'s Mario Kart World Cups:</h2>
                        <div id="cup-grid">
                            {
                                data.worldCups.map((element, index) => {
                                    return <div key={index} className="cup-card">
                                        <Link to={`/browse/cup/${element.id}`} reloadDocument className="cup-link">
                                            <h5 className="cup-title">{element.cupName || "Unnamed World Cup"}</h5>
                                            <div id={`world-cup-${element.id}`} className="cup-mini">
                                                <WorldCup tracks={element.tracks} />
                                            </div>
                                        </Link>
                                        <div className="cup-actions">
                                            <Button
                                                icon={ShareIcon}
                                                text="Copy Link"
                                                color="blue"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    navigator.clipboard.writeText(
                                                        `https://mk8dx-cup-builder.web.app/browse/cup/${element.id}`
                                                    );
                                                    setSmallPop(true);
                                                }}
                                            />
                                            {!isMobile && (
                                                <Button
                                                    icon={DownloadIcon}
                                                    text="Download"
                                                    color="green"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        const cupElement = document.getElementById(`world-cup-${element.id}`);
                                                        if (!cupElement) return;
                                                        toPng(cupElement).then((dataUrl) => {
                                                            const link = document.createElement("a");
                                                            link.download = `${element.cupName || "World Cup"}.png`;
                                                            link.href = dataUrl;
                                                            link.click();
                                                        });
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    </>
                )}

                {data?.cups?.length > 0 && (
                    <>
                        <h2>{data?.displayName}'s Mario Kart 8 Deluxe Cups:</h2>
                        <div id="cup-grid">
                            {
                                data.cups.map((element, index) => {
                                    return <div key={index} className="cup-card">
                                        <Link to={`/mk8dx/browse/cup/${element.id}`} reloadDocument className="cup-link">
                                            <h5 className="cup-title mk8dx-font">{element.cupName || "Unamed MK8DX Cup"}</h5>
                                            <div id={`mk8dx-cup-${element.id}`}>
                                                <CupDisplay
                                                    tracks={element.tracks}
                                                    variant="browse"
                                                    showEmblems={true}
                                                />
                                            </div>
                                        </Link>
                                        <div className="cup-actions">
                                            <Button
                                                icon={ShareIcon}
                                                text="Copy Link"
                                                color="blue"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    navigator.clipboard.writeText(
                                                        `https://mk8dx-cup-builder.web.app/mk8dx/browse/cup/${element.id}`
                                                    );
                                                    setSmallPop(true);
                                                }}
                                            />
                                            {!isMobile && (
                                                <Button
                                                    icon={DownloadIcon}
                                                    text="Download"
                                                    color="green"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        const cupElement = document.querySelector(`#mk8dx-cup-${element.id} .cup-outline`);
                                                        if (!cupElement) return;
                                                        toPng(cupElement).then((dataUrl) => {
                                                            const link = document.createElement("a");
                                                            link.download = `${element.cupName || "MK8DX Cup"}.png`;
                                                            link.href = dataUrl;
                                                            link.click();
                                                        });
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    </>
                )}

                {(!data?.cups || data.cups.length === 0) && (!data?.worldCups || data.worldCups.length === 0) && (
                    <p>No cups created yet.</p>
                )}
            </div>
            {
                smallPop && <SmallPop text="Copied URL to clipboard!"  onClose={() => setSmallPop(null)} />
            }
        </div>
    </div>
}